import { Link } from 'react-router-dom';
import { formatDateToMmDdYyyy } from '../../../utils/formatDate';
import { FormWarning } from '../../common/form';

export const SimilarAddressWarning = ({ similarForms }) => {
  // Early return if no forms
  if (!Array.isArray(similarForms) || similarForms.length === 0) {
    return null;
  }

  return (
    <FormWarning type="warning">
      <p>We found {similarForms.length} open form{similarForms.length > 1 ? 's' : ''} with similar address:</p>
      <div>
        {similarForms.map(form => (
          <div key={form.id}>
            <Link to={`/forms/jsaform/${form.id}`} style={{ color: '#2185d0' }}>
              Form {form.id}
            </Link>
            {' - '}
            <strong>{form.address}</strong>
            {' ('}
            {formatDateToMmDdYyyy(form.date)}
            {form.taskDescription && ` - ${form.taskDescription.substring(0, 30)}${form.taskDescription.length > 30 ? '...' : ''}`}
            {')'}
          </div>
        ))}
      </div>
      <p style={{ fontSize: '0.9em', marginTop: '8px', marginBottom: '0' }}>
        Please verify that you're not creating a duplicate form for the same location.
      </p>
    </FormWarning>
  );
};
